import { cx } from '@/utils/functions/cx';
import './Skeleton.scss';

export interface SkeletonProps {
  /**
   * Skeleton variant
   */
  variant?: 'text' | 'circle' | 'rect';
  /**
   * Width (CSS value)
   */
  width?: string | number;
  /**
   * Height (CSS value)
   */
  height?: string | number;
  /**
   * Additional class name
   */
  className?: string;
}

/**
 * Loading placeholder with shimmer animation
 */
export function Skeleton({ variant = 'text', width, height, className }: SkeletonProps) {
  const classes = cx('skeleton', `skeleton-${variant}`, className);

  const style: React.CSSProperties = {
    width: typeof width === 'number' ? `${width}px` : width,
    height: typeof height === 'number' ? `${height}px` : height,
  };

  return <div className={classes} style={style} aria-hidden="true" />;
}
